import React, { useState, useEffect } from "react";
import LeftMenu01 from "../../../components/layout/leftMenu01.jsx";
import Header from "../../../components/layout/header-candidate.jsx";
import { useLocation } from 'react-router-dom';
import "./candidateassessment.css"
import FormComponent from "./FormComponent.jsx";
export default function CandidateAssessment() {
    const [menuClick, setMenuClick] = useState(false);
    const location = useLocation();
    const { Data } = location.state || {};
    console.log(Data, "received item");

    const toggleMenu = () => {
        setMenuClick(!menuClick)
    }
    const closeMenu = () => {
        setMenuClick(false)
    }
    useEffect(() => {

        setTimeout(() => {
            document.getElementById("assessmentMenu").classList.add("active");
        }, 500);

    }, []);



    return (
        <div className="main-wrapper">
            <div className="top-color"></div>
            <LeftMenu01 menuClick={menuClick} closeMenu={closeMenu} />
            <div className="content-wrapper">
                <Header Header="Candidate Assessment" toggleMenu={toggleMenu} menuClick={menuClick} />
                <div className="main-container">
                    <div className="row mb-3">
                        <div className="col-lg-12 col-md-12">
                            <div className="card main-card-box">
                                <div className="card-body">
                                    <div className="row">
                                        <FormComponent Qndata={Data} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
